// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3J6tI","rootMobile":"styles_rootMobile__34a6f"};